import {useEffect} from 'react'
import {ObjUtil} from 'yougile-util'
import {DataObjectId, HubProperties} from 'yougile-model'
import {SyncEvents} from '@client/sync-events'
import {globals} from '@extensions/globals-base'
import {GeneralBoardSettingsPopupStore} from './generalboard-settings-popup-store'

type Props = {
  boardId?: DataObjectId
  store: GeneralBoardSettingsPopupStore
}

export const useSyncBoard = ({boardId, store}: Props): void => {
  useEffect(() => {
    if (!boardId) {
      return undefined
    }

    const companyId = globals.getCompanyId()

    const listenerId = SyncEvents.addListener(companyId, boardId, () => {
      const board = store.getBoard()
      const actualSettings = board?.data?.settings

      const inStateTimeInColumn = store.state.showTimeTaskInColumn
      const actualTimeInColumn = actualSettings?.showTimeTaskInColumn
      if (actualTimeInColumn && inStateTimeInColumn !== actualTimeInColumn) {
        store.setShowTimeTaskInColumn(actualTimeInColumn)
      }

      const inStateCountMsg = store.state.showCountMsgsInTask
      const actualCountMsg =
        !!board.properties?.[HubProperties.showMessageStatsInBoard]
      if (inStateCountMsg !== actualCountMsg) {
        store.setShowCountMsgsInTask(actualCountMsg)
      }

      const inStateMoveOnDone = store.state.moveTaskToColWhenDone
      const actualMoveOnDone = actualSettings?.moveTaskToColWhenDone
      if (
        actualMoveOnDone &&
        !ObjUtil.deepEqual(inStateMoveOnDone, actualMoveOnDone, false)
      ) {
        store.setMoveTaskToColWhenDone(actualMoveOnDone)
      }

      const inStateAutoCompleteTasks = store.state.autoCompleteTasks
      const actualAutoCompleteTasks = actualSettings?.autoCompleteTasks
      if (
        actualAutoCompleteTasks &&
        inStateAutoCompleteTasks !== actualAutoCompleteTasks
      ) {
        store.setAutoCompleteTasks(actualAutoCompleteTasks)
      }

      const inStateCounterInColumns = store.state.counterInColumns
      const actualCounterInColumns = actualSettings?.counterInColumns
      if (
        actualCounterInColumns &&
        inStateCounterInColumns !== actualCounterInColumns
      ) {
        store.setCounterInColumns(actualCounterInColumns)
      }

      const inStateAutoDone = store.state.autoDoneTaskWhenMoveToCol
      const actualAutoDone = actualSettings?.autoDoneTaskWhenMoveToCol
      if (
        actualAutoDone &&
        !ObjUtil.deepEqual(inStateAutoDone, actualAutoDone, false)
      ) {
        store.setAutoDoneTaskWhenMoveToCol(actualAutoDone)
      }

      const inStateAutoCover = store.state.autoTaskCover
      const actualAutoCover = actualSettings?.autoTaskCover
      if (
        actualAutoCover &&
        !ObjUtil.deepEqual(inStateAutoCover, actualAutoCover, false)
      ) {
        store.setAutoTaskCover(actualAutoCover)
      }

      const isShowIdOnTaskCard = store.state.showIdOnTaskCard
      const actualShowIdOnTaskCard = !!actualSettings?.showIdOnTaskCard
      if (isShowIdOnTaskCard !== actualShowIdOnTaskCard) {
        store.setShowIdOnTaskCard(actualShowIdOnTaskCard)
      }
    })

    return (): void => {
      SyncEvents.removeListener(listenerId)
    }
  }, [boardId])
}
